{
  "nav": {
    "items": {
      "myPage": "Meine Seite"
    }
  },
  "myPage": {
    "subtitle": "Ihre öffentliche Seite auf {{brand}}: Vorlage wählen, Abschnitte anordnen und veröffentlichen.",
    "loading": "Ihre Seite wird vorbereitet",
    "loadFailed": "Ihre Seite konnte nicht geladen werden",
    "railLabel": "Seiteneinstellungen",
    "markdownHint": "Einfache Formatierung wird unterstützt: # Überschrift, **fett**, Listen mit - und Links als [Text](https://…). HTML wird nicht akzeptiert.",
    "markdownHintShort": "**Fett**, Listen mit - und Links werden unterstützt.",
    "tabs": {
      "label": "Bereiche meiner Seite",
      "builder": "Seite bearbeiten",
      "leads": "Anfragen über die Seite"
    },
    "status": {
      "draft": "Entwurf",
      "published": "Veröffentlicht",
      "unpublished": "Zurückgezogen",
      "suspended": "Gesperrt",
      "unknown": "Unbekannt"
    },
    "statusCard": {
      "title": "Seitenstatus",
      "liveUrl": "Adresse Ihrer Seite",
      "futureUrl": "Nach der Veröffentlichung ist die Seite unter dieser Adresse erreichbar",
      "copy": "Adresse kopieren",
      "copied": "Adresse kopiert",
      "copyFailed": "Die Adresse konnte nicht kopiert werden",
      "lastPublished": "Zuletzt veröffentlicht: {{date}}",
      "preview": "Vorschau",
      "openPreview": "Vorschau öffnen",
      "popupBlocked": "Der Browser hat das Vorschaufenster blockiert; verwenden Sie den Link unten.",
      "publish": "Veröffentlichen",
      "republish": "Änderungen veröffentlichen",
      "unpublish": "Veröffentlichung zurückziehen",
      "unpublishTitle": "Veröffentlichung der Seite zurückziehen?",
      "unpublishBody": "Die Seite wird aus dem Internet genommen und ihre Adresse ist nicht mehr erreichbar. Alle Inhalte bleiben erhalten, und Sie können die Seite erneut veröffentlichen.",
      "unpublishConfirm": "Veröffentlichung zurückziehen",
      "unpublished": "Die Veröffentlichung der Seite wurde zurückgezogen",
      "unpublishFailed": "Das Zurückziehen der Veröffentlichung ist fehlgeschlagen. Versuchen Sie es erneut.",
      "blockersTitle": "Ergänzen Sie für die Veröffentlichung bitte Folgendes:",
      "addCouncil": "Ärztekammernummer in Ihrem Profil ergänzen"
    },
    "banner": {
      "suspendedTitle": "Ihre Seite wurde von {{brand}} gesperrt",
      "suspendedNoReason": "Es wurde kein Grund angegeben.",
      "suspendedSupport": "Die Seite ist schreibgeschützt. Wenden Sie sich an den {{brand}}-Support, um die Sperre aufheben zu lassen.",
      "unpublishedChanges": "Sie haben Änderungen, die noch nicht veröffentlicht sind; Besucher sehen die vorherige Version."
    },
    "save": {
      "save": "Speichern",
      "reset": "Zurücksetzen",
      "saving": "Wird gespeichert…",
      "saved": "Gespeichert",
      "dirty": "Nicht gespeicherte Änderungen"
    },
    "publish": {
      "title": "Seite veröffentlichen",
      "intro": "Nach der Veröffentlichung kann Ihre Seite von allen im Internet gesehen und über Suchmaschinen gefunden werden. Bestätigen Sie vor der Veröffentlichung Folgendes:",
      "rule1": "Die Inhalte entsprechen den Werberichtlinien der Ärztekammer und enthalten keine Heilversprechen, keine Erfolgsgarantien und keinen Vergleich mit Kollegen.",
      "rule2": "Die Bilder und Texte stammen von Ihnen, oder Sie haben die Erlaubnis, sie zu verwenden.",
      "rule3": "Patientenstimmen werden mit Einwilligung der Patienten veröffentlicht, und die Seite enthält keine persönlichen medizinischen Daten.",
      "rule4": "Sie sind für die Inhalte der Seite verantwortlich, und {{brand}} kann eine Seite sperren, die diese Regeln nicht einhält.",
      "public": "Die Seite ist öffentlich: Jeder, der ihre Adresse kennt, und Suchmaschinen können sie sehen.",
      "accept": "Ich habe diese Bedingungen gelesen und akzeptiere sie",
      "confirm": "Veröffentlichen",
      "cancel": "Abbrechen",
      "failedTitle": "Veröffentlichung fehlgeschlagen; beheben Sie Folgendes",
      "done": "Ihre Seite wurde veröffentlicht"
    },
    "template": {
      "title": "Vorlage"
    },
    "templates": {
      "classic": {
        "name": "Klassisch",
        "description": "Druckähnlich und ruhig: ein gerahmtes Porträt, ein großer Titel mit hervorgehobener zweiter Hälfte, das Hintergrundbild als Band am oberen Rand und eine Leiste mit Highlights."
      },
      "modern": {
        "name": "Modern",
        "description": "Wie die Startseite einer Praxis: ein großer Titel, ein Hintergrundbild, Karten neben Ihrem Foto und eine Leiste mit Highlights."
      },
      "minimal": {
        "name": "Minimal",
        "description": "Typografisch und luftig, ohne Titelbild; im Mittelpunkt stehen Text, Leistungen und Artikel."
      }
    },
    "palettes": {
      "azure": "Azurblau",
      "teal": "Türkis",
      "deep": "Marineblau",
      "brand": "{{brand}}-Markenfarben",
      "cyan": "Cyan",
      "ink": "Tintenblau"
    },
    "theme": {
      "title": "Farbe und Dichte",
      "palette": "Farbpalette",
      "density": "Dichte",
      "densities": {
        "comfortable": "Großzügig",
        "compact": "Kompakt"
      },
      "onlyTemplate": "Es werden nur die Farbpaletten und Dichten angezeigt, die die aktuelle Vorlage unterstützt."
    },
    "slug": {
      "label": "Seitenadresse",
      "hint": "Kleinbuchstaben (a–z), Ziffern und Bindestriche; 3 bis 40 Zeichen. Standardmäßig ist es Ihre Ärztekammernummer.",
      "lockedHint": "Die Adresse wurde bei der ersten Veröffentlichung festgelegt und kann nicht mehr geändert werden.",
      "required": "Geben Sie eine Adresse ein.",
      "invalid": "Nur Kleinbuchstaben (a–z), Ziffern und Bindestriche, 3 bis 40 Zeichen; Anfang und Ende müssen ein Buchstabe oder eine Ziffer sein, ohne doppelte Bindestriche.",
      "checking": "Wird geprüft…",
      "available": "Diese Adresse ist verfügbar.",
      "taken": "Diese Adresse ist nicht verfügbar.",
      "save": "Adresse speichern"
    },
    "sections": {
      "title": "Abschnitte",
      "reorderHint": "Ändern Sie die Reihenfolge mit den Schaltflächen nach oben und unten (oder mit Alt und den Pfeiltasten).",
      "kinds": {
        "hero": "Berufsprofil",
        "services": "Leistungen",
        "articles": "Artikel",
        "testimonials": "Ausgewählte Patientenstimmen",
        "gallery": "Bildergalerie",
        "video": "Video",
        "office": "Praxisinformationen",
        "booking": "Terminbuchung"
      },
      "show": "„{{name}}“ auf der Seite anzeigen",
      "shown": "Angezeigt",
      "hidden": "Ausgeblendet",
      "hiddenNotice": "Dieser Abschnitt ist ausgeblendet und erscheint nicht auf Ihrer öffentlichen Seite.",
      "showOnPage": "Auf der Seite anzeigen",
      "toggleFailed": "Die Sichtbarkeit von „{{name}}“ konnte nicht geändert werden:",
      "required": "Dieser Abschnitt wird immer angezeigt",
      "moveUp": "„{{name}}“ nach oben verschieben",
      "moveDown": "„{{name}}“ nach unten verschieben",
      "unsupported": "In dieser Vorlage nicht angezeigt",
      "unsupportedLong": "Die aktuelle Vorlage zeigt diesen Abschnitt nicht an. Seine Inhalte bleiben erhalten und erscheinen wieder, wenn Sie die Vorlage wechseln.",
      "hasErrors": "Dieser Abschnitt verhindert die Veröffentlichung",
      "titleOverride": "Abschnittsüberschrift (optional)",
      "titleOverrideHint": "Leer lassen, um die Standardüberschrift anzuzeigen.",
      "reorderFailed": "Die Reihenfolge der Abschnitte wurde nicht gespeichert. Versuchen Sie es erneut.",
      "booking": {
        "intro": "Besucher können eine freie Zeit in einer Ihrer Kliniken wählen oder nur um einen Rückruf bitten. Ob eine Leistung öffentlich und direkt buchbar ist, entscheidet die Klinik.",
        "enabled": "Terminbuchung auf der Seite anzeigen",
        "enabledHint": "Ausgeschaltet bleibt nur das Rückruf-Formular auf der Seite.",
        "clinic": "Klinik",
        "clinicPlaceholder": "Klinik wählen",
        "clinicSingleHint": "Die einzige Klinik, in der Sie Mitglied sind.",
        "noClinicsTitle": "Für die Terminbuchung müssen Sie Mitglied einer Klinik sein",
        "noClinicsBody": "Mitgliedschaften werden unter „Kliniken“ in den Einstellungen verwaltet.",
        "goClinics": "Kliniken",
        "mode": "Art der Terminbuchung",
        "modes": { "slots": "Freie Zeit wählen", "request": "Nur Rückrufanfrage" },
        "modeHints": {
          "slots": "Besucher sehen Ihre freien Zeiten und buchen nach der Anmeldung in der Patienten-App.",
          "request": "Es wird nur das Rückruf-Formular angezeigt."
        },
        "services": "Leistungen",
        "servicesHint": "Es werden nur Leistungen angeboten, die die Klinik öffentlich gemacht hat. Eine Leistung „mit ärztlicher Überweisung“ trägt dieses Kennzeichen und kann von Besuchern nicht direkt gebucht werden.",
        "servicesEmpty": "Diese Klinik hat noch keine öffentliche Leistung für Sie.",
        "kinds": { "direct": "Direkt buchbar", "referral": "Mit ärztlicher Überweisung" },
        "duration": "{{minutes}} Min.",
        "unavailable": "Nicht mehr öffentlich",
        "unavailableHint": "Eine nicht mehr öffentliche Leistung wird beim Speichern entfernt.",
        "horizon": "Angezeigte Tage",
        "horizonDays": "{{days}} Tage",
        "horizonHint": "Freie Zeiten werden für diese Anzahl kommender Tage angezeigt.",
        "previewNote": "Freie Zeiten werden auf der veröffentlichten Seite angezeigt.",
        "loadFailed": "Die Buchungsoptionen konnten nicht geladen werden",
        "errors": {
          "BOOKING_CLINIC_REQUIRED": "Wählen Sie eine Klinik.",
          "BOOKING_CLINIC_NOT_MEMBER": "Sie sind nicht mehr Mitglied dieser Klinik; wählen Sie eine andere.",
          "BOOKING_SERVICES_REQUIRED": "Wählen Sie mindestens eine Leistung.",
          "BOOKING_SERVICE_UNAVAILABLE": "Einige gewählte Leistungen sind nicht mehr öffentlich und werden beim Speichern entfernt."
        }
      }
    },
    "items": {
      "count": "{{count}} von {{max}}",
      "moveUp": "Nach oben",
      "moveDown": "Nach unten",
      "remove": "Entfernen"
    },
    "image": {
      "pick": "Bild auswählen",
      "replace": "Bild ändern",
      "remove": "Bild entfernen",
      "removeTitle": "Bild entfernen?",
      "removeBody": "Das Bild wird von der Seite entfernt. Nach der nächsten Veröffentlichung wird es auch von der öffentlichen Seite entfernt.",
      "removeConfirm": "Entfernen",
      "cropTitle": "Bild zuschneiden",
      "typeUnsupported": "Es werden nur JPEG- oder PNG-Bilder akzeptiert.",
      "tooLarge": "Das Bild ist größer als 5 MB.",
      "readFailed": "Die Datei konnte nicht gelesen werden."
    },
    "hero": {
      "displayName": "Anzeigename",
      "displayNameRequired": "Ein Anzeigename ist erforderlich.",
      "headline": "Kurztitel",
      "headlinePlaceholder": "z. B. Kardiologe, Hochschullehrer",
      "headlineHint": "In den Vorlagen „Modern“ und „Klassisch“ erscheint er groß oben auf der Seite; enthält er ein Komma, wird der Teil danach farbig angezeigt.",
      "about": "Über mich",
      "portrait": "Porträt",
      "portraitHint": "Eine separate Kopie Ihres Profilbilds; Änderungen hier wirken sich nicht auf Ihr Profil aus.",
      "cover": "Hintergrundbild",
      "coverHint": "Ein breites Bild (etwa 3:1). „Modern“ zeigt es abgeschwächt hinter dem oberen Seitenbereich, „Klassisch“ als Band am oberen Rand.",
      "coverUnused": "Die aktuelle Vorlage zeigt kein Hintergrundbild; wählen Sie „Modern“ oder „Klassisch“, um es zu sehen.",
      "extras": {
        "onlyModern": "Diese beiden Listen werden in den Vorlagen „Modern“ und „Klassisch“ angezeigt. Bleiben sie leer, erscheinen stattdessen Ihre ersten Leistungen sowie Ihre Ärztekammernummer, Stadt und Sprechzeiten.",
        "notShown": "Die aktuelle Vorlage zeigt diese beiden Listen nicht an; wählen Sie „Modern“ oder „Klassisch“, um sie zu sehen.",
        "cardsTitle": "Einführungskarten",
        "cardsHint": "Bis zu zwei kurze Karten oben auf der Seite, z. B. „Sprechstunden vor Ort und online“.",
        "addCard": "Karte hinzufügen",
        "highlightsTitle": "Highlights",
        "highlightsHint": "Bis zu drei Einträge in der Leiste unter dem oberen Seitenbereich, z. B. „15 Jahre Erfahrung“.",
        "addHighlight": "Highlight hinzufügen",
        "itemTitle": "Titel",
        "itemText": "Kurzer Text (optional)",
        "titleRequired": "Ein Titel ist erforderlich."
      }
    },
    "services": {
      "itemTitle": "Bezeichnung der Leistung",
      "itemDescription": "Beschreibung",
      "image": "Bild der Leistung",
      "imageHint": "4:3; die Bezeichnung der Leistung dient als Alternativtext des Bildes.",
      "imageAfterSave": "Ein Bild können Sie hinzufügen, nachdem Sie diese Leistung gespeichert haben.",
      "add": "Leistung hinzufügen"
    },
    "testimonials": {
      "framingTitle": "Ausgewählte Stimmen, keine Bewertungen",
      "framing": "Dieser Abschnitt enthält Zitate, die Sie selbst auswählen und eingeben; er wird unter der Überschrift „Ausgewählte Patientenstimmen“ angezeigt. Bewertungen, Sterne oder die Anzahl von Bewertungen werden auf der Seite nicht angezeigt.",
      "text": "Patientenstimme",
      "attribution": "Anzeigename des Patienten",
      "attributionPlaceholder": "z. B. „M. Rezaei“ oder „Patient, 45 Jahre“",
      "consent": "Der Patient hat der Veröffentlichung dieser Patientenstimme auf der öffentlichen Seite zugestimmt",
      "consentRequired": "Ohne bestätigte Einwilligung des Patienten wird diese Patientenstimme nicht gespeichert.",
      "add": "Patientenstimme hinzufügen"
    },
    "video": {
      "intro": "Fügen Sie eine Videoadresse von Aparat oder YouTube ein; gespeichert wird nur die Video-ID.",
      "url": "Videoadresse",
      "caption": "Kurze Bildunterschrift",
      "add": "Video hinzufügen",
      "pending": "Wird beim Speichern geprüft",
      "aparat": "Aparat",
      "youtube": "YouTube"
    },
    "gallery": {
      "alt": "Alternativtext",
      "altRequired": "Ein Alternativtext ist erforderlich.",
      "saveAlt": "Text speichern",
      "newAlt": "Beschreibung des neuen Bildes",
      "newAltPlaceholder": "z. B. „Wartezimmer der Praxis“",
      "altFirst": "Schreiben Sie zuerst die Bildbeschreibung.",
      "emptyTitle": "Noch keine Bilder in der Galerie",
      "emptyHint": "Fügen Sie bis zu 12 Bilder Ihrer Praxis und Ihrer Ausstattung hinzu."
    },
    "articles": {
      "new": "Neuer Artikel",
      "back": "Zurück zu den Artikeln",
      "title": "Titel des Artikels",
      "slug": "Artikeladresse (optional)",
      "slugHint": "Leer lassen, um die Adresse aus dem Titel zu erzeugen. Die Adresse wird bei der ersten Veröffentlichung festgelegt.",
      "slugLocked": "Artikeladresse:",
      "body": "Artikeltext",
      "cover": "Artikelbild",
      "publish": "Artikel veröffentlichen",
      "unpublish": "Auf Entwurf zurücksetzen",
      "republish": "Artikeländerungen veröffentlichen",
      "delete": "Artikel löschen",
      "deleteTitle": "Artikel löschen?",
      "deleteBody": "Der Artikel „{{title}}“ wird endgültig gelöscht.",
      "deleteConfirm": "Löschen",
      "saveFirst": "Speichern Sie Ihre Änderungen vor der Veröffentlichung.",
      "saveToContinue": "Nach dem Speichern können Sie ein Bild hinzufügen und den Artikel veröffentlichen.",
      "untitled": "Ohne Titel",
      "publishedOn": "Veröffentlicht am {{date}}",
      "neverPublished": "Noch nicht veröffentlicht",
      "statusPublished": "Veröffentlicht",
      "statusDraft": "Entwurf",
      "changed": "Nicht veröffentlichte Änderungen",
      "emptyTitle": "Sie haben noch keine Artikel geschrieben",
      "emptyHint": "Informative Artikel für Patienten machen Ihre Seite in Suchmaschinen leichter auffindbar."
    },
    "office": {
      "intro": "Was Sie hier eingeben, wird genau so auf der öffentlichen Seite angezeigt.",
      "phones": "Telefonnummern",
      "phoneLabel": "Bezeichnung",
      "phoneLabelPlaceholder": "z. B. Empfang",
      "phoneNumber": "Nummer",
      "addPhone": "Telefonnummer hinzufügen",
      "city": "Stadt",
      "address": "Praxisadresse",
      "hours": "Sprechzeiten",
      "hoursLabel": "Tage",
      "hoursLabelPlaceholder": "z. B. Samstag bis Mittwoch",
      "hoursValue": "Uhrzeiten",
      "hoursValuePlaceholder": "z. B. 16 bis 20 Uhr",
      "addHours": "Sprechzeiten hinzufügen",
      "geo": "Standort auf der Karte (optional)",
      "geoHint": "Markieren Sie Ihre Praxis auf der Karte, damit Patienten sich von Ihrer Seite aus mit Neshan, Balad oder Google Maps den Weg anzeigen lassen können.",
      "map": {
        "pick": "Auf der Karte wählen",
        "change": "Auf der Karte ändern",
        "close": "Karte schließen",
        "myLocation": "Mein aktueller Standort",
        "clear": "Standort entfernen",
        "isSet": "Ihre Praxis ist auf der Karte markiert.",
        "label": "Karte zur Auswahl des Praxisstandorts",
        "hint": "Tippen Sie auf die Karte oder ziehen Sie die Markierung auf Ihre Praxis, und drücken Sie dann „Speichern“.",
        "found": "Die Markierung steht an Ihrem aktuellen Standort. Wenn Sie gerade nicht in der Praxis sind, verschieben Sie sie auf die Praxis.",
        "locating": "Ihr Standort wird ermittelt…",
        "loading": "Karte wird geladen…",
        "failed": "Die Karte konnte nicht geladen werden. Wenn Sie in der Praxis sind, drücken Sie „Mein aktueller Standort“.",
        "denied": "Der Standortzugriff wurde nicht erlaubt; tippen Sie auf die Karte, um Ihre Praxis zu markieren.",
        "unavailable": "Ihr Standort konnte nicht ermittelt werden; tippen Sie auf die Karte, um Ihre Praxis zu markieren.",
        "timeout": "Die Standortermittlung hat zu lange gedauert; versuchen Sie es erneut oder tippen Sie auf die Karte.",
        "unsupported": "Dieser Browser kann keinen Standort freigeben; tippen Sie auf die Karte, um Ihre Praxis zu markieren."
      },
      "socials": "Soziale Netzwerke",
      "socialsHint": "Geben Sie den Benutzernamen oder die Profiladresse ein (z. B. @dr.example oder instagram.com/dr.example). WhatsApp: die vollständige Nummer mit Ländervorwahl. Website: die vollständige Adresse.",
      "social": {
        "instagram": "Instagram",
        "telegram": "Telegram",
        "whatsapp": "WhatsApp",
        "eitaa": "Eitaa",
        "bale": "Bale",
        "website": "Website"
      }
    },
    "leads": {
      "intro": "Anfragen, die Besucher über Ihre Seite gesendet haben. Das {{brand}}-Team kümmert sich um sie.",
      "name": "Name",
      "mobile": "Mobilnummer",
      "preference": "Kontaktweg und -zeit",
      "message": "Nachricht",
      "createdAt": "Eingegangen",
      "status": "Status",
      "more": "Mehr anzeigen",
      "loadFailed": "Die Anfragen konnten nicht geladen werden",
      "emptyTitle": "Noch keine Anfragen",
      "emptyHint": "Teilen Sie die Adresse Ihrer Seite mit Patienten, damit sie Sie über „Termin anfragen“ erreichen können.",
      "notPublishedTitle": "Die Seite ist noch nicht veröffentlicht",
      "notPublishedHint": "Nach der Veröffentlichung erscheinen hier die Anfragen der Besucher.",
      "channels": {
        "call": "Telefonat",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "times": {
        "morning": "Vormittags",
        "afternoon": "Nachmittags",
        "evening": "Abends",
        "any": "Jederzeit"
      },
      "statuses": {
        "new": "Neu",
        "contacted": "Kontaktiert",
        "qualified": "In Bearbeitung",
        "proposal": "In Bearbeitung",
        "negotiation": "In Bearbeitung",
        "won": "Erledigt",
        "lost": "Geschlossen"
      }
    }
  }
}
